// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__OnbGO","filesListContainer":"PosDisputesFiles_filesListContainer__xbEEU","filesButton":"PosDisputesFiles_filesButton__2DBly"};